import { FC } from 'react';

import { Box, Flex, FormLabel, Radio, Text, useRadio, UseRadioProps } from '@chakra-ui/react';

type RadioCardProps = UseRadioProps & { label: string; info?: string };

export const RadioCard: FC<RadioCardProps> = (props) => {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as='label' cursor='pointer'>
      <input {...input} />
      <Box
        {...checkbox}
        pointerEvents='none'
        borderWidth='1px'
        borderRadius='md'
        p='4'
        bgColor='lighter-gray'
        borderColor='light-gray'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        _checked={{
          bgColor: 'light-green',
          color: 'gray',
          borderColor: 'green',
        }}
        _focus={{
          boxShadow: 'outline',
        }}
      >
        <Flex gap={2}>
          {/* @ts-expect-error */}
          <Radio isChecked={input.checked} />
          <FormLabel htmlFor={input.id} m={0}>
            {props.label}
          </FormLabel>
        </Flex>
        <Text>{props.info}</Text>
      </Box>
    </Box>
  );
};
